// extracted by mini-css-extract-plugin
module.exports = {"stack":"HStack_stack__Vz_Xm"};